import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useCandidates } from '../candidatesContext/useCandidatesContext'

import { Button } from '@percent/lemonade'
import { usePermissionCheck } from '@percent/partner-dashboard/common/hooks/useAllow/usePermissionCheck'
import { EntryType } from '@percent/partner-dashboard/services/grants/grantsService.types'
import { AddOrganisationModal } from './organisationModal/AddOrganisationModal'

export function AddOrganisation() {
  const { t } = useTranslation()
  const { program } = useCandidates()
  const { userCan } = usePermissionCheck()
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (program.entryType !== EntryType.INVITATION || !userCan('inviteGrantCandidates')) {
    return null
  }

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)} variant="primary" data-testid="add-organisation-button">
        {t('grants.candidates.addOrganization.button')}
      </Button>
      <AddOrganisationModal open={isModalOpen} setOpen={setIsModalOpen} />
    </>
  )
}
